module.exports = __webpack_public_path__ + "img/noProject.d03bfb14.png";